import { put, call, takeEvery } from "redux-saga/effects";
import * as apis from "../../network/apis/specialties";
import * as types from "./types";
import * as actions from "./actions";
import { showErrorMsg, showSuccessMsg } from "../../utils/Helpers";
import { ROUTE_PATHS } from "../../utils/RoutesPaths";
import history from "../../routes/History";

function* getSpecialtiesListSaga({ payload }) {
  try {
    const response = yield call(apis.getSpecialtyList, payload);
    yield put(
      actions.getSpecialtiesResponse({
        list: response.data.specialties,
        meta: {
          currentPage: +response.headers["current-page"],
          count: +response.headers["total-count"],
          pages: +response.headers["total-pages"],
        },
      })
    );
    if (+response.headers["current-page"] > +response.headers["total-pages"]) {
      yield put(
        actions.getSpecialtiesRequest({
          ...payload,
          page: +response.headers["total-pages"],
        })
      );
    }
  } catch (error) {
    yield showErrorMsg(error.response?.data?.message);
  }
}

function* addSpecialtySaga({ payload, onSucess }) {
  try {
    yield call(apis.addSpecialty, payload);
    yield showSuccessMsg("addedSuccessfully");
    onSucess();
    // yield history.push(ROUTE_PATHS.specialties);
  } catch (error) {
    yield showErrorMsg(error.response?.data?.message);
  }
}

function* editSpecialtySaga({ payload }) {
  try {
    yield call(apis.editSpecialty, payload);
    yield showSuccessMsg("editedSuccessfully");
    yield history.push(ROUTE_PATHS.viewSpecialties.replace(':id',payload.id));
  } catch (error) {
    yield showErrorMsg(error.response?.data?.message);
  }
}

function* getSpecialtySaga({ payload }) {
  try {
    const response = yield call(apis.getSpecialtyDetails, payload);
    yield put(actions.getSpecialtyDetailsResponse(response.data.specialty));
  } catch (error) {
    yield showErrorMsg(error.response?.data?.message);
  }
}

function* deleteSpecialtySaga({ payload }) {
  try {
    yield call(apis.deleteSpecialty, payload);
    yield showSuccessMsg("deletedSuccessfully");
    if (payload.currentPage) {
      yield put(
        actions.getSpecialtiesRequest({
          items: 10,
          page: payload.currentPage,
        })
      );
    } else {
      history.push(ROUTE_PATHS.specialties);
    }
  } catch (error) {
    yield showErrorMsg(error.response?.data?.message);
  }
}

export default function* SpecialtiesSagas() {
  yield takeEvery(types.GET_SPECIALTIES_REQUEST, getSpecialtiesListSaga);
  yield takeEvery(types.ADD_SPECIALTY_REQUEST, addSpecialtySaga);
  yield takeEvery(types.GET_SPECIALTY_DETAILS_REQUEST, getSpecialtySaga);
  yield takeEvery(types.EDIT_SPECIALTY_REQUEST, editSpecialtySaga);
  yield takeEvery(types.DELETE_SPECIALTY_REQUEST, deleteSpecialtySaga);
}
